import Modal from 'styled-react-modal'

export const StyledModal = Modal.styled`
  width: ${({ width, size }) => width ? width : size ? size : '44vw'};
  height: ${({ height, size, maxHeight }) => maxHeight ? '' : height ? height : size ? size : '44vw'};
  max-height: ${({ maxHeight }) => maxHeight ? `${maxHeight}` : '44vw'};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: ${({ theme }) => theme.white};
  border-radius: 6px;
  overflow-y: ${({ overflowY }) => overflowY ? overflowY : 'auto'};
  ${({ topmost }) => (topmost ? `z-index: 9998` : '')}

  @media (max-width: 1366px) {
    width: ${({ width, size }) => width ? width : size ? size : '50vw'};
  }

  @media (max-width: 1024px) {
    width: ${({ width, size }) => width ? width : size ? size : '60vw'};
    height: ${({ height, size }) => height ? height : size ? size : '80vh'};
  }
  
  @media (max-width: 768px) {
    width: ${({ width, size }) => width ? width : size ? size : '80vw'};
    height: ${({ height, size }) => height ? height : size ? size : '80vh'};
  }

  @media (max-width: 640px) {
    width: ${({ width, size }) => width ? width : size ? size : '90vw'};
    height: ${({ height, size }) => height ? height : size ? size : '60vh'};
    margin-top: -20vh;
  }
`
